import React, { Children, isValidElement, useState } from 'react';
import './changelogPane.css';

function extractDeployDate(children) {
    let date = null;
    const remaining = [];
    Children.forEach(children, (child) => {
        if (isValidElement(child) && child.props?.className === 'deployDate') {
            const raw = child.props.children;
            const text = typeof raw === 'string' ? raw : Array.isArray(raw) ? raw.join('') : '';
            date = text.replace(/^Deployed on:\s*/i, '').trim();
        } else {
            remaining.push(child);
        }
    });
    return { date, remaining };
}

function parseTitle(title) {
    if (!title) return { label: '', version: '' };
    const match = /^(.*?):\s*(.+)$/.exec(title);
    if (match) return { label: match[1].trim(), version: match[2].trim() };
    return { label: '', version: title };
}

export function ChangelogPane(props) {
    const [isOpen, setIsOpen] = useState(!!props?.isOpen);
    const { label, version } = parseTitle(props?.title);
    const { date, remaining } = extractDeployDate(props?.children);

    const toggle = () => {
        setIsOpen((v) => !v);
        window.dispatchEvent(new Event('resize'));
    };

    return (
        <section className={`changelogVersionCard${isOpen ? ' is-open' : ''}`}>
            <button
                type="button"
                className="changelogVersionHeader"
                aria-expanded={isOpen}
                onClick={toggle}
            >
                <span className="changelogVersionChevron" aria-hidden="true">
                    {isOpen ? '▾' : '▸'}
                </span>
                <span className="changelogVersionMeta">
                    {label && <span className="changelogVersionEyebrow">{label}</span>}
                    <span className="changelogVersionTitle">{version}</span>
                </span>
                {date && <span className="changelogVersionDate">{date}</span>}
            </button>
            {isOpen && (
                <div className="changelogVersionBody">
                    {remaining.map((child, idx) => (
                        <div className="changelogVersionBodyRow" key={idx}>
                            {child}
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
}
